import React, { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'

const DojahWalletButton = () => {
  const scriptContainerRef = useRef(null)
  const { company } = useSelector((state) => state.companySlice)

  useEffect(() => {
    // Check if the container exists
    if (scriptContainerRef.current) {
      const script = document.createElement('script')
      script.src = 'https://widget.dojah.io/websdk.js'
      script.async = true // or defer = true, depending on the script needs
      // script.onload = () => console.log('Script loaded!'); // Optional: callback when script loads

      // Append the script to the div
      scriptContainerRef.current.appendChild(script)

      // Clean up the script when the component unmounts
      return () => {
        if (scriptContainerRef.current && script.parentNode) {
          // Check if script.parentNode exists
          scriptContainerRef.current.removeChild(script)
        }
      }
    }
  }, [])
  return (
    <div ref={scriptContainerRef}>
      <dojah-button
        widgetId='680cb914fa2e462bfbcaf246'
        text='Generate account details'
        textColor='#ffffff'
        backgroundColor='#3977DE'
        userData={JSON.stringify({
          first_name: company?.company_name,
          last_name: '',
          dob: '',
        })}
        metaData={JSON.stringify({
          email: company?.email,
          user_id: company?.id,
        })}
      ></dojah-button>
    </div>
  )
}

export default DojahWalletButton
